import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import StockForm from '../components/stock/StockForm';
import StockTable from '../components/stock/StockTable';

const StockPage = () => {
  const [selectedStock, setSelectedStock] = useState(null);

  const handleEdit = (stock) => {
    setSelectedStock(stock);
  };

  const handleFormReset = () => {
    setSelectedStock(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start',
        width: '100%',
        flexWrap: { xs: 'wrap', md: 'nowrap' }, 
        p: 2,
      }}
    >
      {/* Table - Left Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 2,
          p: 2,
          minWidth: 0,
        }}
      >
        <StockTable onEdit={handleEdit} />
      </Paper>

      {/* Form - Right Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 1,
          p: 2,
          minWidth: 300,
        }}
      >
        <StockForm
          selectedStock={selectedStock}
          onReset={handleFormReset}
        />
      </Paper>
    </Box>
  );
};

export default StockPage;
